"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/web.dom.iterable");
var _vue = _interopRequireDefault(require("vue"));
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    data: {
      type: String,
      default: ''
    },
    hasWaterMark: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loadingComponent: null,
      isLoading: false,
      activeName: 'mobile',
      watermark_status: {}
    };
  },
  computed: {
    isShowModel: {
      get: function get() {
        return this.isShow;
      },
      set: function set(val) {
        this.$emit('update:isShow', val);
      }
    }
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,

          spinner: 'cricle_loader',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    },
    isShowModel: function isShowModel(val) {
      if (val) {
        this.activeName = 'pc';
        var imgs = [require("../../../../assets/setting/mobile-model.png")];
        for (var _i = 0, _imgs = imgs; _i < _imgs.length; _i++) {
          var img = _imgs[_i];
          var image = new Image();
          image.src = img;
          image.onload = function () {};
        }
      }
    }
  },
  updated: function updated() {
    this.dataInit();
  },
  mounted: function mounted() {
    var _this2 = this;
    this.$nextTick(function () {
      // 预览时水印效果
      // this.openWatermark()
      _this2.dataInit();
    });
  },
  methods: {
    dataInit: function dataInit() {
      var _this3 = this;
      var _this = this;
      document.querySelectorAll('oembed[url]').forEach(function (element) {
        _this3.loadVideo(element);
      });
      var contentBox = document.querySelector('.preview-wrap');
      if (!contentBox) return;
      contentBox.addEventListener('click', function (e) {
        // console.log(e)
        if (e.target.className.includes('attachment-title')) {
          var uuid = e.target.children[0].innerText;
          console.log('uuid---', uuid);
          if (!uuid) return;
          _this.downloadAttachment(uuid);
        }
      });
    },
    loadVideo: function loadVideo(element) {
      console.log(element);
      console.log(element.attributes.url.value);

      // const parent = element.parentNode
      var url = element.getAttribute('url');
      // const anchor = document.createElement('video')

      // anchor.setAttribute('src', url)
      // anchor.className = 'embedly-card'

      // parent.appendChild(anchor)

      var VideoEl = _vue.default.extend({
        template: "<div style=\"position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;pointer-events: auto;\"><video controls style=\"position: absolute; width: 100%; height: 100%; top: 0; left: 0;\" src=\"".concat(url, "\"></video></div>")
      });
      // const videoComponent = new videoEl().$mount()
      // parent.appendChild(videoComponent)
      new VideoEl().$mount('oembed');
    },
    changePreview: function changePreview(type) {
      this.activeName = type;
      this.$nextTick(function () {
        // 预览时水印效果
        // this.openWatermark()
      });
    },
    downloadAttachment: function downloadAttachment(uuid) {
      var _this4 = this;
      this.isLoading = true;
      this.$api.common.downloadFile(uuid).then(function (res) {
        _this4.isLoading = false;
        location.href = res.data + '&token=' + _this4.$store.getters.sasToken;
      }).catch(function () {
        _this4.isLoading = false;
      });
    },
    openWatermark: function openWatermark() {
      if (!this.hasWaterMark || this.watermark_status[this.activeName]) return;
      var settings = this.activeName === 'pc' ? {} : {
        watermark_x_space: 60,
        watermark_y_space: 80,
        watermark_width: 30,
        watermark_height: 20,
        watermark_fontsize: '12px'
      };
      (0, _index.watermark)(document.querySelector(".content-box-".concat(this.activeName)), settings);
      this.watermark_status[this.activeName] = true;
    }
  }
};